import { AfterViewInit, ApplicationRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { RegistrationFormProvider } from '../../services/registration-form.provider';
import { TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.less']
})
export class Step1Component implements OnInit, AfterViewInit {
  public registrationForm: FormGroup;
  public signinWithSocial = false;

  @Output() next = new EventEmitter<void>();

  placholders: any;

  constructor(
    private applicationRef: ApplicationRef,
    private registrationFormProvider: RegistrationFormProvider,
    private translation: TranslateService
  ) {
    this.registrationForm = registrationFormProvider.registrationForm;
  }

  passwordInputFocused = false;

  ngOnInit() {
    this.translation
      .get('placeholders')
      .pipe(take(1))
      .subscribe(data => (this.placholders = data));
  }

  ngAfterViewInit(): void {
    setTimeout(() => document.querySelector<HTMLInputElement>('[name="firstName"]').focus(), 300);
  }

  page1Valid() {
    return this.registrationFormProvider.isStep1Valid();
  }

  showValidationErrors() {
    this.registrationFormProvider.step1MarkAsTouched();
  }

  goToStep2() {
    if (!this.page1Valid()) {
      this.showValidationErrors();
    } else {
      this.next.emit();
    }
  }

  get validationTipsErrors() {
    const validators = {
      numbers: false,
      mixedCase: false,
      specialChars: false,
      length: false
    };

    return { ...validators, ...this.registrationForm.controls['password'].errors };
  }

  get isPasswordTipsOpen() {
    if (this.passwordInputFocused) {
      return true;
    }

    // if (!!this.registrationForm.controls['password'].value) {
    //   return true;
    // }

    return this.registrationForm.controls['password'].invalid && this.registrationForm.controls['password'].touched;
  }
}
